"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DMSErrorCode;
(function (DMSErrorCode) {
    DMSErrorCode[DMSErrorCode["access_denied"] = 0] = "access_denied";
    DMSErrorCode[DMSErrorCode["unknown_error"] = 1] = "unknown_error";
    DMSErrorCode[DMSErrorCode["unhandled_message"] = 2] = "unhandled_message";
    DMSErrorCode[DMSErrorCode["malformed_payload"] = 3] = "malformed_payload";
    DMSErrorCode[DMSErrorCode["rate_limited"] = 4] = "rate_limited";
})(DMSErrorCode || (DMSErrorCode = {}));
exports.default = DMSErrorCode;
//# sourceMappingURL=DMSErrorCode.js.map